import Vue from 'vue';

const frontendApiUrl = process.env.VUE_APP_FUBON_FRONTEND_API_URL;

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  menu: null,
  goodsInfo: null
};

// getters
const getters = {};

// actions
const actions = {
  //- 取得商品型態分類
  index({commit}, data) {
    return Vue.prototype.$frontendAxios.get(`${frontendApiUrl}/sale-product/menu`,{
      params: data
    })
      .then( res => {
        commit('setMenu', res.data);
      });
  },
  //- 取得商品分類詳細內容
  show({commit}, data) {
    return Vue.prototype.$frontendAxios.get(`${frontendApiUrl}/sale-product`,{
      params: data
    })
      .then( res => {
        commit('setGoodsInfo', res.data);
      });
  },
};

// mutations
const mutations = {
  //- 設定商品型態分類
  setMenu(state, data) {
    Vue.set(state, 'menu', data.data.data);
  },
  //- 設定商品詳細內容
  setGoodsInfo(state, data) {
    Vue.set(state, 'goodsInfo', data.data.data);
  },
  //- 重新設定商品詳細內容
  resetGoodsInfo(state) {
    Vue.set(state, 'goodsInfo', null);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
